export default __webpack_public_path__ + "static/media/Protocol.28d47cc3.png";